/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// Klaviyo Back in stock for Complimentary products

(function () {
  var params = new URLSearchParams(window.location.search);
  if (!params.has('bis')) return;

  function tryOpenBIS() {
    // Most common container from your working HTML
    var btn = document.querySelector('#klaviyo-bis-button-container button');

    // Fallback: Klaviyo sometimes renders without the container id; use a11y identifier
    if (!btn) btn = document.querySelector('button[data-a11y-identifier^="bis-button"]');

    if (btn) {
      btn.click();

      // Clean URL so it doesn't re-open on refresh
      params.delete('bis');
      var newUrl =
        window.location.pathname +
        (params.toString() ? '?' + params.toString() : '') +
        window.location.hash;
      window.history.replaceState({}, '', newUrl);

      return true;
    }
    return false;
  }

  // Try immediately
  if (tryOpenBIS()) return;

  // Retry while Klaviyo injects
  var attempts = 0;
  var maxAttempts = 80; // ~8 seconds
  var timer = setInterval(function () {
    attempts++;
    if (tryOpenBIS() || attempts >= maxAttempts) clearInterval(timer);
  }, 100);
})();
